class College {

    public readonly id : number;
    public readonly name: string;
    public readonly count: number

    constructor(id: number,name: string,count: number) {
        this.id = id
        this.name = name
        this.count = count
    }
}

export default College;


// WEBPACK FOOTER //
// ./src/models/College.ts